import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createPaymentMethod,
  deletePaymentMethod,
  getActivePaymentMethods,
  getPaymentMethods,
  updatePaymentMethod,
  type PaymentMethodCreatePayload,
  type PaymentMethodUpdatePayload,
} from "../api/paymentMethods";

export const usePaymentMethods = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["payment-methods"],
    queryFn: getPaymentMethods,
    staleTime: 1000 * 60 * 30, // 30 min
    enabled: options?.enabled ?? true,
  });
};

// Активните методи за текущата сесия — само в Ordering модула.
// Резолват се на бекенда спрямо device_payment_methods + shared/personal user.
export const useActivePaymentMethods = () => {
  return useQuery({
    queryKey: ["payment-methods", "active"],
    queryFn: getActivePaymentMethods,
    staleTime: 1000 * 60 * 30, // 30 min
  });
};

// Създаване — POST /payment-methods
export const useCreatePaymentMethod = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: PaymentMethodCreatePayload) => createPaymentMethod(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payment-methods"] });
    },
  });
};

// Редакция — PUT /payment-methods/:id
export const useUpdatePaymentMethod = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: number;
      data: PaymentMethodUpdatePayload;
    }) => updatePaymentMethod(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payment-methods"] });
    },
  });
};

// Изтриване — DELETE /payment-methods/:id
// Бекендът каскадно трие линкове в device_payment_methods, затова
// инвалидираме и devices кеша.
export const useDeletePaymentMethod = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deletePaymentMethod(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payment-methods"] });
      queryClient.invalidateQueries({ queryKey: ["devices"] });
    },
  });
};
